import { Slider } from "@/components/ui/slider";
import { formatCurrency } from "@/lib/portfolioCalculations";

interface PortfolioSizeSliderProps {
  value: number;
  min: number;
  max: number;
  onChange: (value: number[]) => void;
}

const PortfolioSizeSlider = ({ value, min, max, onChange }: PortfolioSizeSliderProps) => {
  return (
    <div className="pt-4">
      <Slider
        value={[value]}
        min={min}
        max={max}
        step={10000}
        onValueChange={onChange}
        className="max-w-md"
      />
      <div className="flex justify-between text-sm text-gray-500 mt-2 max-w-md">
        <span>{formatCurrency(min)}</span>
        <span>{formatCurrency(max)}</span>
      </div>
    </div>
  );
};

export default PortfolioSizeSlider;